module.exports = __webpack_public_path__ + "img/fish.35cd0e7d.png";